import React from "react";
import AutoBillFinalizeForm from "./AutoBillFinalizeForm";
import RaiseElectricityBillForm from "./RaiseElecticityBillForm";
import EnabledForRentalForm from "./EnableForRentalForm";

const SettingsTab = (props) => {
  const {distributorDetails} = props;

  return (
    <div className="container-fluid">
      <div className="row my-2 py-2">

        <div className="col-md-6">
          <form autoComplete="off" className="card m-2">
            <AutoBillFinalizeForm distributorDetails={distributorDetails} />
          </form>
        </div>
        <div className="col-md-6">
          <form autoComplete="off" className="card m-2">
            <RaiseElectricityBillForm distributorDetails={distributorDetails} />
          </form>
        </div>
        <div className="col-md-6">
          <form autoComplete="off" className="card m-2">
            <EnabledForRentalForm distributorDetails={distributorDetails} />
          </form>
        </div>

      </div>
    </div>
  )
}

export default SettingsTab;
